const paymentCreatedTimestamp = (value) => {
  if (!value) return null;
  const firestoreDate = value?.toDate?.() || (
    typeof value?.seconds === "number" ? new Date(value.seconds * 1000) : null
  );
  if (firestoreDate) {
    const timestamp = firestoreDate.getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  const text = String(value).trim();
  const britishDate = text.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/,
  );
  const date = britishDate
    ? new Date(
        Number(britishDate[3]),
        Number(britishDate[2]) - 1,
        Number(britishDate[1]),
        Number(britishDate[4] || 0),
        Number(britishDate[5] || 0),
        Number(britishDate[6] || 0),
      )
    : new Date(value);
  const timestamp = date.getTime();
  return Number.isNaN(timestamp) ? null : timestamp;
};

export const orderIoRowsForExport = (rows = []) => rows
  .map((row, sourceIndex) => ({ row, sourceIndex }))
  .sort((left, right) => {
    const leftTimestamp = paymentCreatedTimestamp(left.row.PaymentCreated);
    const rightTimestamp = paymentCreatedTimestamp(right.row.PaymentCreated);
    if (leftTimestamp === null && rightTimestamp === null) {
      return left.sourceIndex - right.sourceIndex;
    }
    if (leftTimestamp === null) return 1;
    if (rightTimestamp === null) return -1;
    return leftTimestamp - rightTimestamp || left.sourceIndex - right.sourceIndex;
  })
  .map(({ row }) => row);
